module.exports = __webpack_public_path__ + "static/media/Apple_Pay_logo.63d2e145.svg";